import { UpdateClaimStatusEntity } from '../../domain/entities/update-claim-satus.entity';

export class UpdateClaimStatusModel extends UpdateClaimStatusEntity {
  override toJson(): Map<string, any> {
    let json: Map<string, any> = new Map();
    json.set('id', this.claimId);
    json.set('status', this.status);
    if (this.reasonForRejection) {
      json.set('reason_for_rejection', this.reasonForRejection);
    }
    if (this.rejectionFile && this.rejectionFile.length > 0) {
      json.set('rejection_file', this.rejectionFile);
    }
    json.set('type_admitted', this.typeAdmimited);
    return json;
  }
}
